<template>
	<div class="scoreBox">
		<div class="scoreBoxTitle">
			<div class="scoreBoxTitle-left">
				<img src="../../assets/tennis/icon2.png" alt="">
				<span>2023五星网球分级挑战赛年终总决赛</span>
			</div>
			<div class="scoreBoxTitle-right">
				<div class="btnBox33">
					<div class="mainBoxCon-m1">
						<van-dropdown-menu active-color="#619568" :overlay="false">
						  <van-dropdown-item @change="onchange" v-model="trackid" :options="trackids" />
						</van-dropdown-menu>
					</div>
				</div>
				<div class="btnBox">
					<img src="../../assets/tennis/icon3.png" alt="">
					<span>设置模式</span>
				</div>
				<div class="btnBox">
					<img src="../../assets/tennis/icon4.png" alt="">
					<span>退出登录</span>
				</div>
			</div>
		</div>
		<div class="setting">
			<div class="setting-left">
				<div class="setting-left-img">
					<img src="../../assets/tennis/icon8.png" alt="">
				</div>
				<div class="setting-left-class">
					<div class="set-m1">
						组别设置
					</div>
				</div>
			</div>
			<div class="setting-right">
				<div class="xuanshou1">
					<img src="../../assets/tennis/icon5.png" alt="">
					<span>设置组别</span>
				</div>
				<div class="mainBox">
					<div class="mainBoxCon">
						<div class="mainBoxCon-title">当前打分组别:</div>
						<div class="mainBoxCon-m1">
							<van-dropdown-menu active-color="#619568" :overlay="false">
							  <van-dropdown-item v-model="value1" :options="option1" />
							</van-dropdown-menu>
						</div>
						<!-- <div class="mainBoxCon-title">选择局数:</div> -->
					</div>
				</div>
				<div class="btnBox">
					<van-button type="primary" @click="toPage">确定</van-button>
				</div>
			</div>
		</div>
		
	</div>
</template>

<script>
export default {
	name: 'score',
	data(){
		return {
			value1: 0,
			option1: [
				{ text: '第21轮 —— 第24组：刘云坤、周嘉成', value: 0 },
				{ text: '第1轮 —— 第4组：刘云坤、周嘉成', value: 1 },
				{ text: '第1轮 —— 第4组：刘云坤、周嘉成', value: 2 },
			],
			
			trackids: [],
			trackid: 0,
			
		}
	},
	mounted() {
		this.matchid = this.$route.query.matchid
		// this.trackid = this.$route.query.trackid
		if(this.$route.query.groupnum == ''){
			this.groupnum = ''
			// this.value1 = ''
		}else{
			this.groupnum = this.$route.query.groupnum
			// this.value1 = this.$route.query.groupnum
		}
		var data = {
			matchid: this.matchid
		}
		this.getTrackid(data);
	},
	methods: {
		onchange(){
			console.log("uiuiui", this.trackid)
			this.getData()
		},
		toPage(){
			this.option1.forEach((item, index) => {
				if(this.value1 == item.value){
					if(item.state == 2){
						this.$router.push({
							name: 'tennisdashboard',
							query: {
								matchid: this.matchid,
								trackid: this.trackid,
								groupnum: this.value1
							}
						})
						
					}else{
						this.$toast({
							className: 'mytoast',
							type: 'fail',
							message: '暂时不能打分!',
							// duration: 0
						});
					}
				}
				
			})
			
		},
		getData(){
			let _this = this
			
			var data = {
				matchid: this.matchid,
				trackid: this.trackid,
			}
			
			this.$api.tennis
				.getPersonsData(data)
				.then((res) => {
					if (res.status * 1 === 200) {
						// option1: [
						// 	{ text: '第21轮 —— 第24组：刘云坤、周嘉成', value: 0 },
						// 	{ text: '第1轮 —— 第4组：刘云坤、周嘉成', value: 1 },
						// 	{ text: '第1轮 —— 第4组：刘云坤、周嘉成', value: 2 },
						// ],
						let arr = []
						res.data.forEach((item, index) => {
							if(item.enrollinfo.length == 2){
								var nitem = {
									value: item.groupnum,
									text: `${item.groupname}:${item.enrollinfo[0].name}、${item.enrollinfo[1].name}`,
									state: 2,
								}
							}
							if(item.enrollinfo.length == 1){
								var nitem = {
									value: item.groupnum,
									text: `${item.groupname}:${item.enrollinfo[0].name}`,
									state: 1,
								}
							}
							if(item.enrollinfo.length == 0){
								var nitem = {
									value: item.groupnum,
									text: `${item.groupname}: --`,
									state: 0,
								}
							}
							arr.push(nitem)
						})
						this.option1 = arr
						if(this.$route.query.groupnum == ''){
							this.value1 = this.option1[0].value
						}else{
							this.value1 = this.$route.query.groupnum
						}
					}
			});
		},
		getTrackid(data){
			this.$api.tennis
				.getTrackid(data)
				.then((res) => {
					if (res.status * 1 === 200) {
						// option1: [
						// 	{ text: '第21轮 —— 第24组：刘云坤、周嘉成', value: 0 },
						// 	{ text: '第1轮 —— 第4组：刘云坤、周嘉成', value: 1 },
						// 	{ text: '第1轮 —— 第4组：刘云坤、周嘉成', value: 2 },
						// ],
						var arr = []
						res.data.forEach((item, index) => {
							arr.push({
								text: item.name,
								value: item.trackid
							})
						})
						this.trackids = arr
						this.trackid = this.$route.query.trackid ? this.$route.query.trackid : this.trackids[0].value
						// this.trackid = 
						this.getData()
						// this.getAllPerson()
					}
			});
		},
	}
}
</script>

<style lang="less" scoped>
@import './index.less';
</style>
